import { Input } from "antd";
import { styled } from "styled-components";

export const UpperCaseInput = styled(Input)`
  text-transform: uppercase;
  & input {
    text-transform: uppercase;
  }
`